
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warranty-partners",
      function () {
        return require("private-next-pages/warranty-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warranty-partners"])
      });
    }
  